import {
  Component,
  HostBinding,
  Input,
  Output,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  Renderer2,
  EventEmitter
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subscription ,  Observable } from 'rxjs';
import { SearchService } from '../search.service';



import * as _ from 'lodash';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';

import { SearchModel } from '../search.model';
import {distinctUntilChanged} from 'rxjs/operators';


@Component({
  moduleId: module.id,
  selector: 'search-form',
  templateUrl: 'search-form.component.html',
  styleUrls: ['search-form.component.scss'],
})
export class SearchFormComponent implements OnInit, OnDestroy {

  @Input() searchService: SearchService;

  @Input() placeholder: string = 'Search for a product by name or other information…';

  @Input() cancelPlaceholder: string = 'Cancel';

  @Input() hasListIcon: boolean = false;

  @Input() listIsShown: boolean = false;

  @Input() hasAdvancedSearch: boolean = false;

  /*
    searchByCall = false - hide Search button and run search
    on keydown inside input

    searchByCall = true - show Search button and run search
    on Search button click or on Enter keydown
  */
  @Input() searchByCall: boolean = false;

  @Input() ghostValue: string;

  @Input() advancedSearchOpened: boolean = false;

  @Input() searchModel: SearchModel;

  // typeahead inputs
  @Input() isTypeahead: boolean = false;
  @Input() dataSource: Observable<any>;
  @Input() typeaheadOptionField: string = 'option';

  // small search icon and placeholder styles
  @HostBinding('class.size-small')
  @Input() isSmall: boolean = false;

  @ViewChild('searchFormInput', {static: false}) input: ElementRef | void;

  @Output() searchValueChangedEvent: EventEmitter<string> = new EventEmitter();

  @Output() clearAll: EventEmitter<string> = new EventEmitter();

  @Output() listIconClick: EventEmitter<boolean> = new EventEmitter();

  @Output() advancedSearchToggle: EventEmitter<boolean> = new EventEmitter();

  // Search button or Enter was clicked
  @Output() searchCall: EventEmitter<boolean> = new EventEmitter();

  @Output() cancelClick: EventEmitter<boolean> = new EventEmitter();

  @Output() typeaheadSelect: EventEmitter<any> = new EventEmitter();

  searchTerm = new UntypedFormControl();
  typeAheadControl: UntypedFormControl;
  typeaheadLoading: boolean;
  typeaheadNoResults: boolean;

  private subscription: Subscription;

  constructor(
    private rd: Renderer2,
  ) {}

  get searchTermValue(): string {
    return this.searchTerm.value || '';
  }

  get typeAheadValue(): string {
    return this.typeAheadControl ? this.typeAheadControl.value : '';
  }

  ngOnInit() {
    if (this.isTypeahead) {
      this.typeAheadControl = new UntypedFormControl();
    } else {
      // emit searchValueChangedEvent on each input changes
      this.searchTerm.valueChanges
        .pipe(distinctUntilChanged())
        .subscribe(
          (event) => this.searchValueChangedEvent.emit(event.trim())
        );
    }

    if (this.searchService) {
      this.subscription = this.searchService.toggleFormEvent.subscribe((toggle: boolean) => {
        if (!toggle) { return; }
        _.delay(() => {
          if (this.input) {
            this.input.nativeElement.focus();
          }
        }, 200);
      });
    }
  }

  ngOnDestroy() {
    if (this.subscription) { this.subscription.unsubscribe(); }
  }

  resetValue(value: any = '') {
    _.defer(() => this.searchTerm.reset(value));
  }

  onCancelBtnClick() {
    if (this.hasAdvancedSearch) {
      this.resetValue(this.searchModel.searchValue);
      this.cancelClick.emit();
    } else if (this.searchByCall) {
      this.cancelClick.emit();
    } else {
      this.searchTerm.reset('');
      if (this.searchService) { this.searchService.toggleForm(false); }
      this.clearAll.emit();
    }
  }

  onListIconClick() {
    this.listIconClick.emit();
  }

  onAdvancedSearchClick() {
    this.advancedSearchToggle.emit();
  }

  onSearchClick() {
    this.searchCall.emit();
  }

  onEnter(value: string) {
    if (this.hasAdvancedSearch || this.searchByCall) {
      this.searchCall.emit();
    }
  }

  // typeahead handlers
  handleTypeaheadLoading(e: boolean): void {
    this.typeaheadLoading = e;
  }

  handleTypeaheadNoResults(e: boolean): void {
    this.typeaheadNoResults = e;
  }

  handleTypeaheadOnBlur(e: any) {
    this.typeAheadControl.setValue(null);
  }

  onSelectTypeahead(e: TypeaheadMatch): void {
    this.typeAheadControl.setValue(null);
    this.typeaheadSelect.emit(e);
  }
}
